import * as echarts from 'echarts';
import { jsonParse } from '@/libs/tools';

class EchartsComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
        #chart {
          width: 100%;
          height: 100%;
          max-height: 300px;
        }
      </style>
      <div id="chart" style="width:100%; height:100%;"></div>
    `;
    this.chartDom = this.shadowRoot.getElementById('chart');
    this.chartInstance = null;
    this.resizeObserver = null;
  }

  static get observedAttributes() {
    return ['width', 'height', 'options'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(89765);
    if (name === 'width' || name === 'height') {
      const width = this.getAttribute('width');
      const height = this.getAttribute('height');
      this.chartDom.style.width = `${width}px` || '100%';
      this.chartDom.style.height = `${height}px` || '100%';
      this.updateSize();
    } else if (name === 'options') {
      const options = jsonParse(newValue);
      if (options) {
        this.updateChart(options);
      }
    }
  }

  connectedCallback() {
    this.updateSize();
    this.chartInstance = echarts.init(this.chartDom);

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
      });
      this.resizeObserver.observe(this);
    }

    if (this.getAttribute('options')) {
      console.log('connectedCallback');
      const options = jsonParse(this.getAttribute('options'));
      if (options) {
        this.updateChart(options);
      }
    }
  }

  updateSize() {
    const width = this.getAttribute('width') || '100%';
    const height = this.getAttribute('height') || '100%';
    this.chartDom.style.width = width;
    this.chartDom.style.height = height;
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  updateChart(options) {
    if (this.chartInstance) {
      try {
        this.chartInstance.setOption(options);
      } catch (e) {
        console.log(e);
      }
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  }
}

customElements.define('echarts-component', EchartsComponent);
